import React, { useState } from "react";
import PropTypes from "prop-types";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { OverlayTrigger, Spinner, Tooltip } from "react-bootstrap";
import { formatearFecha, generateCSV } from "../../../core/utils";



const ExporData = ({ showPdf = false, showPrint = false, showExcel = false, data = [], onPrint }) => {

    const [exporting, setExporting] = useState(false);

    const renderTooltip = (props) => (
        <Tooltip id="pdf-tooltip" {...props}>
            Exportar a Pdf
        </Tooltip>
    );
    const renderExcelTooltip = (props) => (
        <Tooltip id="excel-tooltip" {...props}>
            Exportar a Excel
        </Tooltip>
    );
    const renderPrinterTooltip = (props) => (
        <Tooltip id="printer-tooltip" {...props}>
            Imprimir
        </Tooltip>
    );

    const onExportExcel = async () => {
        setExporting(true);
        await generateCSV(data, `export_${formatearFecha(new Date().toISOString(), "yyMMddHHmmss")}.csv`);
        setExporting(false);
    }

    return (
        <>
            {showPdf &&
                <li>
                    <OverlayTrigger placement="top" overlay={renderTooltip}>
                        <a>
                            <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                        </a>
                    </OverlayTrigger>
                </li>
            }
            {showExcel &&
                <li>
                    <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                        {
                            exporting
                                ?
                                <a>
                                    <Spinner animation="border" variant="primary" size="sm" />
                                </a>
                                :
                                <a onClick={() => onExportExcel()}>
                                    <ImageWithBasePath
                                        src="assets/img/icons/excel.svg"
                                        alt="img"
                                    />
                                </a>
                        }
                    </OverlayTrigger>
                </li>
            }
            {showPrint &&
                <li>
                    <OverlayTrigger placement="top" overlay={renderPrinterTooltip}>
                        <a onClick={() => onPrint()}>
                            <i data-feather="printer" className="feather-printer" />
                        </a>
                    </OverlayTrigger>
                </li>
            }
        </>
    );
};

ExporData.propTypes = {
    showPdf: PropTypes.bool,
    showPrint: PropTypes.bool,
    showExcel: PropTypes.bool,
    data: PropTypes.array,
    onPrint: PropTypes.func,
};

export default ExporData;
